import { api } from './api';

export enum Feedback {
  REJECT = 0,
  LIKE = 1,
}

export enum SuggestionType {
  MATCH = 1,
  LIKE_YOU = 2,
}

export const FEEDBACK_LABELS = {
  [Feedback.REJECT]: 'Rejected',
  [Feedback.LIKE]: 'Liked',
};

export const SUGGESTION_TYPE_LABELS = {
  [SuggestionType.MATCH]: 'Match',
  [SuggestionType.LIKE_YOU]: 'Like You',
};

export interface MatchResult {
  scoreA: number;
  scoreB: number;
}
export interface TestMatchDto {
  userAId: string;
  userBId: string;
  saveMatch: boolean;
}

export interface MatchOneUserDto {
  userId: string;
}

export interface MatchOneUserResponse {
  success: boolean;
  message: string;
}

export interface UserMatchesResponse {
  userId: string;
  totalMatches: number;
  matches: UserMatch[];
}

export interface Suggestion {
  id: string;
  userId: string;
  isViewed: boolean;
  feedback: number | null;
  type: number;
  reason?: string;
  createdAt: string;
}

export interface UserMatch {
  matchId: number;
  matchedUser: {
    id: string;
    name?: string;
    email: string;
  };
  scores: {
    userScore: number;
    matchedUserScore: number;
  };
  status: any;
  reason?: string;
  suggestion?: Suggestion | null;
  createdAt: string;
  updatedAt: string;
}

export interface MatchDetailsResponse {
  matchId: number;
  isPrimary: boolean;
  status: string;
  userA: {
    id: string;
    name?: string;
    email: string;
    gender?: string;
  };
  userB: {
    id: string;
    name?: string;
    email: string;
    gender?: string;
  };
  scores: {
    userAScore: number;
    userBScore: number;
  };
  reasons: {
    reasonForUserA?: string;
    reasonForUserB?: string;
  };
  suggestions?: {
    suggestionForUserA?: Suggestion | null;
    suggestionForUserB?: Suggestion | null;
  };
  timestamps: {
    createdAt: string;
    updatedAt: string;
  };
}

export const matchTestApi = api.injectEndpoints({
  endpoints: (builder) => ({
    testMatch: builder.mutation<MatchResult, TestMatchDto>({
      query: ({ userAId, userBId, saveMatch = false }) => ({
        url: '/matches/test/matchAi',
        method: 'POST',
        body: {
          userAId,
          userBId,
          saveMatch,
        },
      }),
    }),
    matchOneUser: builder.mutation<MatchOneUserResponse, MatchOneUserDto>({
      query: ({ userId }) => ({
        url: '/matches/test/matchOneUser',
        method: 'POST',
        body: {
          userId,
        },
      }),
    }),
    getUserMatches: builder.query<UserMatchesResponse, string>({
      query: (userId) => ({
        url: `/matches/admin/user/${userId}/matches`,
        method: 'GET',
      }),
      providesTags: (result, error, userId) => [
        { type: 'UserMatches', id: userId },
      ],
    }),
    getMatchDetails: builder.query<MatchDetailsResponse, number>({
      query: (matchId) => ({
        url: `/matches/admin/match/${matchId}/details`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useTestMatchMutation,
  useMatchOneUserMutation,
  useGetUserMatchesQuery,
  useGetMatchDetailsQuery,
} = matchTestApi;
